import { Button, CircularProgress, Tooltip, Typography } from '@mui/material'

interface Props {
  title: string
  subTitles?: string[]
  submitText?: string
  onClose: () => void
  isSubmitting: boolean
  centerElement?: React.ReactNode
  titleAdornment?: React.ReactNode
  onSubmit?: () => void
  canSubmit?: boolean
  showSubmit?: boolean
  submitTooltip?: string
}

export function FormHeader({
  title,
  subTitles = [],
  submitText,
  isSubmitting,
  onClose,
  onSubmit,
  centerElement,
  titleAdornment,
  canSubmit = true,
  showSubmit = true,
  submitTooltip,
}: Props) {
  return (
    <div className="flex justify-between mb-6">
      <div>
        <div className="flex items-center gap-2">
          <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
          {titleAdornment}
        </div>
        {subTitles.map((subTitle, index) => (
          <Typography key={index} variant="body2" color="text.secondary">{subTitle}</Typography>
        ))}
      </div>

      {centerElement && <div className="flex-1 flex items-center justify-center">{centerElement}</div>}

      <div className="flex items-center space-x-4">
        {showSubmit && (
          <Tooltip title={submitTooltip ?? ''} disableHoverListener={!submitTooltip}>
            <span>
              <Button
                type={onSubmit ? 'button' : 'submit'}
                variant="contained"
                disabled={isSubmitting || !canSubmit}
                startIcon={isSubmitting ? <CircularProgress size={18} /> : null}
                onClick={onSubmit ?? undefined}
              >
                {submitText ?? 'Valider'}
              </Button>
            </span>
          </Tooltip>
        )}

        <Button
          type="button"
          variant="outlined"
          disabled={isSubmitting}
          onClick={onClose}
          startIcon={isSubmitting ? <CircularProgress size={18} /> : null}
        >
          Fermer
        </Button>
      </div>
    </div>
  )
}
